module.exports = __webpack_public_path__ + "static/media/003-baie_de_beauport_6.78d1238f.jpeg";